module.exports = __webpack_public_path__ + "assets/icons/ic_rotate_left-7f65.svg";